// @flow

import * as React from 'react';

import PreviewImage, { NextButton, PreviousButton } from './PreviewImage';

import styles from './PreviewImages.scss';

export type PreviewImageType = {|
  url: string | null,
  placeholder: string | null
|};

type Props = {|
  images: Array<PreviewImageType> | void,
  linkWrapper: ({| children: React.Node |}) => React.Node
|};

type State = {|
  index: number,
  images: Array<PreviewImageType>
|};

export default class PreviewImages extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { images: images = [] } = this.props;
    this.state = {
      index: 0,
      images: images
    };
  }

  render(): React.Node {
    const { index, images } = this.state;
    const { linkWrapper } = this.props;
    const image = images[index];
    const showControls = images.length > 1;

    return (
      <div className={styles.container}>
        {linkWrapper({ children: <PreviewImage image={image} /> })}
        {showControls && <NextButton handleClick={this.nextImage} />}
        {showControls && <PreviousButton handleClick={this.prevImage} />}
      </div>
    );
  }

  nextImage: () => void = () => {
    this.setState((prevState: State) => {
      const newIndex = nextIndex(prevState);
      return { index: newIndex };
    });
  };

  prevImage: () => void = () => {
    this.setState((prevState: State) => {
      const newIndex = prevIndex(prevState);
      return { index: newIndex };
    });
  };
}

function nextIndex(state: State): number {
  const {
    index: currIdx,
    images: { length: imagesCount }
  } = state;
  return (currIdx + 1) % imagesCount;
}

function prevIndex(state: State): number {
  const {
    index: currIdx,
    images: { length: imagesCount }
  } = state;
  return (currIdx + imagesCount - 1) % imagesCount;
}
